import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { SessionProvider } from "../../auth/SessionContext";
import { DeploymentTargetProvider } from "../../features/deployments/DeploymentTargetContext";
import { PendingInvitationsBanner } from "../../features/org-invitations/PendingInvitationsBanner";

/**
 * The authenticated app shell. Wraps every route nested under it in
 * `SessionProvider` (ADR-0004 P5.0/F6) — the one place `/api/auth/me` is
 * fetched — so `useSession()` is available to the sidebar, Settings, Teams,
 * and Forms sharing UI. Deliberately excludes the public form respondent
 * routes, which render outside this layout (ADR-0004 E4 invariant). Also
 * hosts the signed-in user's pending-invitation banner on every page.
 */
export function AppLayout() {
  return (
    <SessionProvider>
      <DeploymentTargetProvider>
        <div className="flex min-h-screen flex-col bg-gray-50 lg:h-screen lg:flex-row">
          <Sidebar />
          <main className="min-w-0 flex-1 overflow-auto">
            <PendingInvitationsBanner />
            <Outlet />
          </main>
        </div>
      </DeploymentTargetProvider>
    </SessionProvider>
  );
}
